/* === CART DRAWER FINAL (v12) === */
(function(){
  console.log("[DAC drawer build v11 - 2026-07-15]");
  const S = {
    overlay:'#CartDrawerOverlay',
    drawer:'#CartDrawer',
    items:'#CartDrawerItems',
    total:'#CartDrawerTotal',
    money:'#CartDrawerMoneyFormat',
    i18n:'#CartDrawerI18n'
  };
  const qs = s => document.querySelector(s);

  /* ---------- Translations (read from Liquid, English fallbacks) ---------- */
  function getI18n(){
    const fallback = {
      remove:'Remove',
      empty:'Your cart is empty',
      decrease_quantity:'Decrease quantity',
      increase_quantity:'Increase quantity'
    };
    try{
      const el=qs(S.i18n);
      return el ? Object.assign(fallback, JSON.parse(el.textContent||'{}')) : fallback;
    }catch(e){ return fallback; }
  }
  const t = getI18n();

  /* ---------- Money helpers ---------- */
  function fallbackFormatMoney(cents, fmt){
    if(typeof cents==='string') cents=cents.replace('.','');
    const v = (cents/100);
    const g = (n,th=',',de='.')=>{
      const p=n.toFixed(2).split('.');
      p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);
      return p.join(de);
    };
    fmt = fmt || '{{amount}}';
    let num;
    if(fmt.includes('amount_no_decimals')) num = Math.round(v).toString();
    else if(fmt.includes('with_comma_separator')) num = g(v,'.',',');
    else if(fmt.includes("with_apostrophe_separator")) num = g(v,"'",'.');
    else num = g(v,',','.');
    // keep the surrounding currency symbol/text from the shop money format
    return /{{.*?}}/.test(fmt) ? fmt.replace(/{{.*?}}/, num) : num;
  }
  function getMoneyFormat(){
    try{
      const el=qs(S.money);
      return el?JSON.parse(el.textContent||'{}').money_format:'{{amount}}';
    }catch(e){return'{{amount}}';}
  }
  const state = { moneyFormat:getMoneyFormat(), currency:null };
  const money = (cents)=>{
    // Prefer per-market currency from /cart.js (Shopify Markets: EUR, USD, ...)
    if (state.currency && window.Intl && Intl.NumberFormat){
      try{
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency: state.currency }).format(cents/100);
      }catch(e){}
    }
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, state.moneyFormat);
    return fallbackFormatMoney(cents, state.moneyFormat);
  };
  function setCheckoutTotal(cents){ const b=document.getElementById('CartDrawerCheckoutTotal'); if(b) b.textContent = money(cents); }

  /* ---------- Helpers ---------- */
  const addWidth=(url,w)=>!url?'':(url.indexOf('?')===-1?`${url}?width=${w}`:`${url}&width=${w}`);
  const isAddEndpoint=(url,method='GET')=>/\/cart\/add(\.js)?(\?|$)/i.test(url||'') && (method||'GET').toUpperCase()==='POST';

  /* ---------- Drawer controls ---------- */
  function openDrawer(){
    const o=qs(S.overlay), d=qs(S.drawer);
    if(!o||!d) return;
    o.hidden=false; d.hidden=false;
    o.style.display='block';               // an app stylesheet force-hides the overlay; inline display wins
    d.style.display='';
    void o.offsetWidth;                    // reflow so the fade still animates (no rAF: throttle-proof)
    o.classList.add('open'); d.classList.add('open');
    o.style.opacity='1';
    document.documentElement.style.overflow='hidden';
    document.documentElement.classList.add('cart-drawer-open');
  }
  function closeDrawer(){
    const o=qs(S.overlay), d=qs(S.drawer);
    if(!o||!d) return;
    o.classList.remove('open'); d.classList.remove('open'); o.style.opacity='0';
    setTimeout(()=>{ o.hidden=true; d.hidden=true; o.style.display='none'; }, 220);
    document.documentElement.style.overflow='';
    document.documentElement.classList.remove('cart-drawer-open');
  }

  /* ---------- Shopify cart APIs ---------- */
  // Read the cart through the market root (/fr/cart.js etc.) so product names come back in the shopper's language
  const cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const fetchCart=()=>fetch(cartRoot+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'}).then(r=>r.json());
  const changeLine=(line,quantity)=>fetch('/cart/change.js',{
    method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
    credentials:'same-origin', body:JSON.stringify({line,quantity})
  }).then(r=>r.json());
  const addToCartForm=(form)=>fetch('/cart/add.js',{
    method:'POST', headers:{Accept:'application/json'},
    credentials:'same-origin', body:new FormData(form)
  }).then(r=>{ if(!r.ok) return r.json().then(e=>Promise.reject(e)); return r.json(); });

  /* ---------- Render (price under title on mobile via CSS classes) ---------- */
  function lineItemTemplate(item, idx){
    const raw=item.image||(item.featured_image&&(item.featured_image.url||item.featured_image.src))||'';
    const img=addWidth(raw,160);
    const variant=(item.options_with_values||[])
      .filter(o=>o.value&&o.name&&o.value.toLowerCase()!=='default title')
      .map(o=>o.value).join(' / ');

    return `
      <div class="cart-drawer__item" data-line="${idx+1}">
        <a href="${item.url}" tabindex="-1">
          <img class="cart-drawer__thumb" src="${img}" alt="">
        </a>

        <div class="cart-drawer__info">
          <a href="${item.url}" class="cart-drawer__title-link">${item.product_title||item.title}</a>

          <!-- MOBILE price (under title) -->
          <div class="cart-drawer__price cart-drawer__price--mobile">
            <s class="line-was" data-vid="${item.variant_id}" style="display:none"></s>
            ${money(item.final_line_price)}
          </div>

          ${variant?`<div class="cart-drawer__variant">${variant.toUpperCase()}</div>`:''}

          <div class="cart-drawer__qtyrow">
            <div class="cart-drawer__qty">
              <button type="button" class="js-qty-dec" aria-label="${t.decrease_quantity}">−</button>
              <input type="number" class="js-qty-input" min="0" value="${item.quantity}">
              <button type="button" class="js-qty-inc" aria-label="${t.increase_quantity}">+</button>
            </div>
            <button type="button" class="cart-drawer__remove js-remove">${t.remove}</button>
          </div>
        </div>

        <!-- DESKTOP price (right column; hidden on phones via CSS) -->
        <div class="cart-drawer__price cart-drawer__price--desktop">
          <s class="line-was" data-vid="${item.variant_id}" style="display:none"></s>
          ${money(item.final_line_price)}
        </div>
      </div>`;
  }

  function renderCart(cart){
    const root=qs(S.items); if(!root) return;
    if(cart && cart.currency) state.currency = cart.currency;
    if(!cart || !cart.items || !cart.items.length){
      root.innerHTML=`<p>${t.empty}</p>`;
      qs(S.total).textContent = money(0);
      setCheckoutTotal(0);
      return;
    }
    root.innerHTML = cart.items.map(lineItemTemplate).join('');
    qs(S.total).textContent = money(cart.total_price);
    setCheckoutTotal(cart.total_price);

    // NEW: fill the <s class="line-was"> and Total (was)
    applyCompareAt(cart);
  }
  const refreshAndOpen = ()=>fetchCart().then(c=>{ renderCart(c); openDrawer(); });

  /* ---------- Events ---------- */
  document.addEventListener('click', e=>{
    // Close on overlay / close button
    if(e.target.closest('.cart-drawer__close') || e.target===qs(S.overlay)){
      closeDrawer();
      return;
    }

    /* mark upsell-open immediately on checkout click (do NOT prevent default) */
    const checkoutLink = e.target.closest('.cart-drawer__checkout, a[href="/checkout"]');
    if (checkoutLink) {
      document.documentElement.classList.add('upsell-open');
      // allow default navigation / app interception
    }

    // Qty / Remove
    const dec=e.target.closest('.js-qty-dec'),
          inc=e.target.closest('.js-qty-inc'),
          rm=e.target.closest('.js-remove');
    if(dec||inc||rm){
      const row=e.target.closest('.cart-drawer__item'); if(!row) return;
      const line=parseInt(row.getAttribute('data-line'),10);
      const input=row.querySelector('.js-qty-input'); let q=parseInt(input.value,10)||0;
      if(dec) q=Math.max(0,q-1); if(inc) q=q+1; if(rm) q=0;
      input.value=q; changeLine(line,q).then(renderCart);
      return;
    }

    // Manual open trigger
    const trigger=e.target.closest('a[href="#cart"], .js-open-cart-drawer, button[data-open-cart]');
    if(trigger){ e.preventDefault(); refreshAndOpen(); }
  });

  document.addEventListener('change', e=>{
    if(!e.target.matches('.js-qty-input')) return;
    const row=e.target.closest('.cart-drawer__item'); if(!row) return;
    changeLine(parseInt(row.getAttribute('data-line'),10), parseInt(e.target.value,10)||0).then(renderCart);
  });

  document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeDrawer(); });

  // 1) Catch standard product form submits
  document.addEventListener('submit', e=>{
    const f=e.target; if(!(f instanceof HTMLFormElement)) return;

    const action=(f.getAttribute('action')||'').replace(location.origin,'').split(/[?#]/)[0];
    // Also match market paths like /fr/cart/add and /fr-be/cart/add (was English only)
    if(!/^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/add(\.js)?$/i.test(action)) return;
    e.preventDefault();
    e.stopImmediatePropagation();   // stop the theme's own add-to-cart handler from also firing
    if(f.__cdAdding) return;         // guard against a rapid double submit
    f.__cdAdding = true;
    const addBtn = f.querySelector('[type="submit"], [name="add"]');
    if(addBtn) addBtn.disabled = true;
    // IMPORTANT: native f.submit() must ONLY run when the AJAX add itself fails.
    // (Previously a failed *refresh* also triggered f.submit(), which added a 2nd item.)
    addToCartForm(f).then(
      function(){ refreshAndOpen().catch(function(){}); },  // add OK -> refresh only, never re-add
      function(){ f.submit(); }                             // add FAILED -> native submit as last resort
    ).finally(()=>{ f.__cdAdding = false; if(addBtn) addBtn.disabled = false; });
  }, true);

  // 2) Catch ANY fetch() to /cart/add(.js)
  if(!window.__cartDrawerFetchPatched){
    const _fetch=window.fetch;
    window.fetch=function(input, init){
      let url=typeof input==='string'?input:(input&&input.url)||'';
      let method=(init&&init.method)||(typeof input!=='string'&&input&&input.method)||'GET';
      const isAdd=isAddEndpoint(url,method);
      return _fetch.apply(this, arguments).then(res=>{
        if(isAdd && (res && (res.ok || res.status===200))) setTimeout(refreshAndOpen, 0);
        return res;
      });
    };
    window.__cartDrawerFetchPatched=true;
  }

  // 3) Catch ANY XHR to /cart/add(.js)
  if(!window.__cartDrawerXHRPatched){
    const _open=XMLHttpRequest.prototype.open, _send=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(method,url){
      this.__cd_isAdd=isAddEndpoint(url,method);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send=function(body){
      this.addEventListener('load', ()=>{
        if(this.__cd_isAdd && this.status>=200 && this.status<400) setTimeout(refreshAndOpen, 0);
      });
      return _send.apply(this, arguments);
    };
    window.__cartDrawerXHRPatched=true;
  }

  // 4) Fallback: click on [name="add"] (lets theme run its AJAX, then open)
  document.addEventListener('click', e=>{
    if(e.target.closest('[name="add"]')){
      setTimeout(refreshAndOpen, 500);
    }
  });

  // 5) Open if URL hash is #cart
  document.addEventListener('DOMContentLoaded', ()=>{ if(location.hash==='#cart') refreshAndOpen(); });

  /* === Detect upsell popups and toggle .upsell-open automatically === */
  (function watchUpsell(){
    const UPS_SELECTOR = [
      '.lb-addon-popup-container',
      '#lb-addon-popup-container-id',
      '.lb-addon-popup-bg',
      'lb-upsell-addon-popup',
      '.selleasy-upsell',
      '.upsell-modal'
    ].join(',');

    const toggle = () => {
      // an upsell container merely EXISTING in the DOM (Selleasy keeps one parked
      // permanently) must not count — only a VISIBLE popup demotes the drawer
      let open = false;
      document.querySelectorAll(UPS_SELECTOR).forEach(el => {
        if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) open = true;
      });
      document.documentElement.classList.toggle('upsell-open', open);
    };

    const mo = new MutationObserver(toggle);
    if (document.body) mo.observe(document.body, { childList:true, subtree:true });
    toggle();
  })();

  // Debug helpers
  window.CartDrawer = { open:()=>refreshAndOpen(), close:()=>closeDrawer() };

  /* Reservation countdown: 15 min, restarts when it reaches zero */
  (function reservationTimer(){
    function start(){
      var box = document.querySelector('.cart-drawer__reserve');
      var el  = box && box.querySelector('.cart-drawer__reserve-timer');
      if(!el) return;
      var mins = parseInt(box.getAttribute('data-reserve-min'),10) || 15;
      var total = mins*60, remain = total;
      function fmt(s){ var m=Math.floor(s/60), ss=s%60; return (m<10?'0':'')+m+':'+(ss<10?'0':'')+ss; }
      el.textContent = fmt(remain);
      setInterval(function(){ remain--; if(remain<0) remain = total; el.textContent = fmt(remain); }, 1000);
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  /* =======================
     Compare-at (WAS) PATCH
     ======================= */

  const cmpCache = {};     // variant_id -> compare_at_price cents
  const cmpPending = {};   // prevent duplicate fetches

  function toCents(v){
    if (v == null) return 0;
    if (typeof v === 'number') return Math.round(v);
    if (typeof v === 'string'){
      const t=v.trim(); if(!t) return 0;
      return t.includes('.') ? Math.round(parseFloat(t)*100) : Math.round(parseInt(t,10));
    }
    return 0;
  }

  function fetchCompare(variantId){
    if (cmpCache.hasOwnProperty(variantId)) return Promise.resolve(cmpCache[variantId]);
    if (cmpPending[variantId]) return cmpPending[variantId];
    cmpPending[variantId] = fetch('/variants/'+variantId+'.js', { credentials:'same-origin' })
      .then(r=>r.ok?r.json():{})
      .then(v=>{ cmpCache[variantId] = toCents(v && (v.compare_at_price || v.compare_at_price_min)); return cmpCache[variantId]; })
      .catch(()=>{ cmpCache[variantId]=0; return 0; })
      .finally(()=>{ delete cmpPending[variantId]; });
    return cmpPending[variantId];
  }

  function applyCompareAt(cart){
    // 1) load compares for all variants in this cart
    const vids = Array.from(new Set((cart.items||[]).map(i=>i.variant_id)));
    Promise.all(vids.map(fetchCompare)).then(()=>{

      // 2) per-line: show <s.line-was> inside each price node
      const rows = document.querySelectorAll('#CartDrawerItems .cart-drawer__item');
      rows.forEach((row, idx)=>{
        const it = (cart.items||[])[idx]; if(!it) return;
        const qty = Number(it.quantity)||1;
        const nowUnit = Number(it.final_price || it.price || 0);
        const cmpUnit = Number(cmpCache[it.variant_id] || 0);
        const show = (cmpUnit > nowUnit) && nowUnit > 0;

        const targets = row.querySelectorAll('.cart-drawer__price--mobile, .cart-drawer__price--desktop, .cart-drawer__price');
        targets.forEach(host=>{
          const s = host.querySelector('s.line-was');
          if (!s) return; // created in template above
          if (show){
            s.textContent = money(cmpUnit * qty);
            s.style.display=''; s.hidden=false;
          } else {
            s.style.display='none'; s.hidden=true;
          }
        });
      });

      // 3) total (was): sum compare-at if present, else current
      const totalEl = qs(S.total);
      if (totalEl){
        let st = totalEl.querySelector('.cart-total-was');
        if (!st){
          st = document.createElement('s');
          st.className = 'cart-total-was';
          totalEl.insertAdjacentElement('afterbegin', st); // inside, before current total
        }
        let before = 0;
        (cart.items||[]).forEach(it=>{
          const qty = Number(it.quantity)||1;
          const nowUnit = Number(it.final_price || it.price || 0);
          const cmpUnit = Number(cmpCache[it.variant_id] || 0);
          before += (cmpUnit>0 ? cmpUnit : nowUnit) * qty;
        });
        const after = Number(cart.total_price)||0;
        if (before > after){
          st.textContent = money(before);
          st.style.display=''; st.hidden=false;
        } else {
          st.style.display='none'; st.hidden=true;
        }
      }

      // You saved today — compare-at markdown + any discounts (drawer only)
      const savingsRow = document.getElementById('CartDrawerSavingsRow');
      const savingsVal = document.getElementById('CartDrawerSavings');
      if (savingsRow && savingsVal){
        let baseline = 0;
        (cart.items||[]).forEach(it=>{
          const qty = Number(it.quantity)||1;
          const origLine = Number(it.original_line_price || it.line_price || it.final_line_price || 0);
          const cmpLine  = Number(cmpCache[it.variant_id] || 0) * qty;
          baseline += Math.max(cmpLine, origLine);
        });
        const saved = baseline - (Number(cart.total_price)||0);
        if (saved > 0){
          savingsVal.textContent = money(saved);
          savingsRow.hidden = false; savingsRow.style.display = '';
        } else {
          savingsRow.hidden = true; savingsRow.style.display = 'none';
        }
      }
    }).catch(()=>{ /* never block cart */ });
  }

})();